export interface Coordinates {
	latitude: number;
	longitude: number;
}

export type FlatCoordinates = [number, number]; // [longitude, latitude]

export function areCoordinatesEqual(a: Coordinates, b: Coordinates): boolean {
	return (a.latitude === b.latitude && a.longitude === b.longitude);
}

export function flattenCoordinates(coordinates: Coordinates): FlatCoordinates {
	return [coordinates.longitude, coordinates.latitude];
}

export function lngLatToCoordinates(lngLat: FlatCoordinates): Coordinates {
	return { longitude: lngLat[0], latitude: lngLat[1] };
}

export function createDefaultCoordinates(): Coordinates {
	return {
		latitude: 0,
		longitude: 0
	};
}

export function createCoordinateKey(coordinates: Coordinates): string {
	return `${coordinates.latitude},${coordinates.longitude}`;
}

/**
 * Type guard to check if an object is a Coordinates object.
 * @param obj The value to check, of unknown type.
 * @returns True if the object conforms to the Coordinates interface.
 */
export function isCoordinates(obj: unknown): obj is Coordinates {
	if (typeof obj !== 'object' || obj === null) {
		return false;
	}
	const potentialCoordinates = obj as Record<string, unknown>;
	return (
		typeof potentialCoordinates.latitude === 'number' &&
		typeof potentialCoordinates.longitude === 'number'
	);
}

export function randomCoordinates(): Coordinates {
	return {
		latitude: Math.random() * 180 - 90,
		longitude: Math.random() * 360 - 180
	};
}